// extracted by mini-css-extract-plugin
export default {"errWrap":"style_errWrap__G2nGs","wrap":"style_wrap__9p6lf","btn":"style_btn__xnyhA"};